import React from 'react';
import Icon from '../../../components/AppIcon';

const ExperienceInput = ({ value, onChange, error, required = false }) => {
  const handleIncrement = () => {
    const newValue = Math.min((value || 0) + 1, 50);
    onChange(newValue);
  };

  const handleDecrement = () => {
    const newValue = Math.max((value || 0) - 1, 0);
    onChange(newValue);
  };

  const handleInputChange = (e) => {
    const inputValue = parseInt(e?.target?.value) || 0;
    const clampedValue = Math.max(0, Math.min(inputValue, 50));
    onChange(clampedValue);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-foreground">
        سال‌های تجربه
        {required && <span className="text-destructive mr-1">*</span>}
      </label>
      
      <div className="relative">
        <div className="flex items-center border border-border rounded-md bg-input">
          {/* Decrement Button */}
          <button
            type="button"
            onClick={handleDecrement}
            disabled={value <= 0}
            className="p-3 text-muted-foreground hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-smooth focus-ring rounded-r-md"
          >
            <Icon name="Minus" size={16} />
          </button>
          
          {/* Input Field */}
          <input
            type="number"
            min="0"
            max="50"
            value={value || 0}
            onChange={handleInputChange}
            className="flex-1 px-3 py-2 text-center bg-transparent border-0 focus:outline-none focus:ring-0 text-foreground"
            placeholder="0"
          />
          
          {/* Increment Button */}
          <button
            type="button"
            onClick={handleIncrement}
            disabled={value >= 50}
            className="p-3 text-muted-foreground hover:text-foreground disabled:opacity-50 disabled:cursor-not-allowed transition-smooth focus-ring rounded-l-md"
          >
            <Icon name="Plus" size={16} />
          </button>
        </div>
      </div>

      <p className="text-xs text-muted-foreground">
        تعداد سال‌های فعالیت حرفه‌ای در زمینه وکالت
      </p>

      {/* Error Message */}
      {error && (
        <p className="text-sm text-destructive flex items-center">
          <Icon name="AlertCircle" size={16} className="ml-2" />
          {error}
        </p>
      )}
    </div>
  );
};

export default ExperienceInput;